import http from '@/services/http.js';

export const fetchTasks = async (userid, role, status, filters = {}, page = 1, limit = 8) => {
  try {
    const params = {
      id: userid,
      role: role,
      status: status,
      page,
      limit,
      ...filters, // 展开筛选参数 (clientId, companyName, clientName, assignedStaff)
    };

    // 移除空值参数，但保留assignedStaff的空字符串（表示未分配）
    Object.keys(params).forEach((key) => {
      if (
        (params[key] === '' && key !== 'assignedStaff') ||
        params[key] === null ||
        params[key] === undefined
      ) {
        delete params[key];
      }
    });

    const response = await http.get(`/videoapi/infoUpload/getAllInfo`, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error('获取任务列表失败', error);
    throw error;
  }
};


export const fetchTask = async (client_id) => {
  const data = await http.get(`/videoapi/infoUpload/getInfo/${client_id}`);

  return data.data;
};

export const selectOrderVideo = async (clientId, source, jobId) => {
  const response = await http.put(
    `/videoapi/infoUpload/orders/${encodeURIComponent(clientId)}/selected-video`,
    {
      source,
      job_id: jobId,
    },
  );
  return response.data.data;
};


export const startWorkflow = async (
  client_id,
  user_id,
  flow_type,
  useKlingApi
) => {
  const response = await http.post(`/videoapi/automationFlow/start`, {
    client_id,
    user_id,
    flow_type,
    useKlingApi,
  });
  return response;
};


export const updateTaskStatus = async (client_id, status) => {
  try {
    const response = await http.put(
      `/videoapi/infoUpload/updateStatus/${client_id}`,
      { status }
    );
    return response;
  } catch (error) {
    console.error('更新任务状态失败', error);
    throw error;
  }
};


export const confirmTextTask = async (
  client_id,
  speech_text,
  farewell_text,
  role
) => {
  try {
    const response = await http.put(
      `/videoapi/infoUpload/confirm/${client_id}`,
      { speech_text, farewell_text, role }
    );
    return response;
  } catch (error) {
    console.error('确认文本失败', error);
    throw error;
  }
};
